import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import VueSlickCarousel from 'vue-slick-carousel'
import AOS from 'aos'
import 'aos/dist/aos.css'
 
import SimpleLineIcons from 'vue-simple-line'
import VueAnimateOnScroll from 'vue-animate-onscroll'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueI18n from 'vue-i18n'

import messages from './locale'

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueI18n)

if(!localStorage.getItem('language')){
  localStorage.setItem('language', 'en')
}
const i18n = new VueI18n({
  locale: localStorage.getItem('language'), // set locale
  messages, // set locale messages
})
Vue.component('simple-line-icons', SimpleLineIcons)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCp6x4Ki0kZMuIIwyNynKee39NFrKwTzyw',
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.config.productionTip = false

Vue.use(VueSlickCarousel);

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
Vue.use(VueAnimateOnScroll);

// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)
new Vue({
  created () {
    AOS.init({
      once: true
   })
  },
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
